import TextArea from './TextArea';
import './TextArea.scss';

export default TextArea;
